import * as actionTypes from "./actionTypes";

const initialState = {
  error: false,
  errorMessage: "",
  message: "",
  loading: false,
  BlockedDomainList: [],
};

const BlockedDomain = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_BLOCKED_DOMAIN_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: "",
      };
    case actionTypes.CREATE_BLOCKED_DOMAIN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.CREATE_BLOCKED_DOMAIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.errorMessage,
      };
    case actionTypes.UPDATE_BLOCKED_DOMAIN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.UPDATE_BLOCKED_DOMAIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.errorMessage,
      };
    case actionTypes.GET_BLOCKED_DOMAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        BlockedDomainList: action.payload,
      };
    case actionTypes.GET_BLOCKED_DOMAIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.errorMessage,
      };

    default:
      return state;
  }
};

export default BlockedDomain;
